<template>
    <v-dialog max-width="400px" v-model="dialog" persistent>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 0px">
                    Không xác nhận
                </v-toolbar-title>
            </v-toolbar>
            <v-btn
                @click="close"
                icon
                style="position: absolute; right: 10px; top: 10px; color: #fff"
            >
                <v-icon>cancel</v-icon>
            </v-btn>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field
                            type="text"
                            :label="$t('lang.common.reason')"
                            v-model.trim="reason_reject"
                            v-validate="'required'"
                            name="reason"
                            maxlength="2000"
                            :data-vv-as="$t('lang.common.reason')"
                            :error-messages="errors.first('reason')"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.confirm") }}
                </v-btn>
                <v-btn color="error" @click="close">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {message} from "@/shared/message";

export default {
    name: "dialog_reject_confirm",
    components: { },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            reason_reject: '',
        };
    },

    watch: {
        
    },

    created() {
        
    },

    methods: {
        close() {
            this.$emit("close");
        },
        save() {
          this.$validator.validate().then(valid => {
            if (!valid) {
              message.error(this.$t("lang.common.validate_fail"));
              return;
            }
            this.$emit("onRejectConfirm", this.reason_reject);
          })


        },
    },
    destroyed() {},
};
</script>
